import { render, staticRenderFns } from "./PriorityEditor.vue?vue&type=template&id=292c11b1"
import script from "./PriorityEditor.vue?vue&type=script&lang=js"
export * from "./PriorityEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports